import axios from 'axios';
import { arrayChunks } from 'app/utils/utils';
import { FolderItem, SongFolderResponse } from 'types/song';
import { Link } from 'types/api.types';
import { UpdateFolderEffectData } from './effects.types';

export const getUpdatedFolderItem = async ({
  link,
  data: { title, addSongs, removeSongs },
}: {
  link: Link;
  data: Omit<UpdateFolderEffectData, 'guid'>;
}) => {
  const getBodies = () => {
    const chunkSize = 50;
    if (addSongs) {
      return arrayChunks(addSongs, chunkSize).map((songs) => ({
        addSongs: songs,
      }));
    }
    if (removeSongs) {
      return arrayChunks(removeSongs, chunkSize).map((songs) => ({
        removeSongs: songs,
      }));
    }
    return [{ title }];
  };

  const promises = getBodies().map((body) =>
    axios.request<SongFolderResponse>({
      url: link.href,
      method: link.method,
      data: body,
      withCredentials: true,
    })
  );

  const responses = await promises.reduce<any>(
    async (accumulator, currentPromise) => {
      const results = await accumulator;
      return [...results, await currentPromise];
    },
    Promise.resolve([])
  );

  return responses.reduce(
    (
      acc,
      {
        data: {
          response: {
            folder: { item: folderItem },
          },
        },
      }
    ) => {
      if (
        (addSongs && acc.songCount < folderItem.songCount) ||
        (removeSongs && acc.songCount > folderItem.songCount)
      ) {
        return folderItem;
      }
      return acc;
    },
    responses?.[0]?.data?.response?.folder?.item
  ) as FolderItem;
};
